var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonThumbsDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1206.000000, -1909.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Common/Thumbs/Down",
    transform: "translate(1206.000000, 1909.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.666386,11.526 C28.4453893,8.49 27.8723869,5.277 25.8183782,2.939 C24.5323728,1.475 22.8533658,0.561 21.0323581,0.2 C20.5933563,0.076 20.1293544,0.001 19.6413523,0 L11.478318,0.343 C9.68931049,0.402 8.06430367,1.568 7.3103005,3.191 C5.67229362,7.086 4.573289,11.24 4.12828713,15.555 C4.08028693,16.023 4.04028676,16.489 4.00728662,16.953 L4.01528666,16.973 C3.858286,18.499 4.92829049,19.734 6.41229673,19.772 L20.3733554,19.894 L19.7833529,27.314 C19.573352,29.243 20.3263552,31.451 22.2473632,32 L27.666386,11.526 Z",
    id: 202
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonThumbsDown);
export default __webpack_public_path__ + "static/media/common-thumbs-down.05825d21.svg";
export { ForwardRef as ReactComponent };